
import { AddressVerificationEffect } from './address-verification.effect';
import { CardTypesEffects } from './card-types.effect';
import { CheckoutEffects } from './checkout.effect';
import { CustomPaymentTypesEffects } from './custom-payment-types.effect';
import { ReplenishmentOrderEffects } from './replenishment-order.effect';


export const effectsCheckout: any[] = [
  CheckoutEffects,
  AddressVerificationEffect,
  CardTypesEffects,
  CustomPaymentTypesEffects,
  ReplenishmentOrderEffects,
];

export * from './address-verification.effect';
export * from './card-types.effect';
export * from './checkout.effect';
export * from './custom-payment-types.effect';
export * from './replenishment-order.effect';

